import { useState, useEffect } from "react";
import { loadCityList } from "../services/locationService";
import { loadEmployeeList } from "../services/employeeService";


const useApprovedByEmployee = (editShiftAssignmentID) => {
    const [approvedBy, setApprovedBy] = useState([]);
    const [selectedApprovedBy, setSelectedApprovedBy] = useState(null);
    const [selectedApprovedByID, setSelectedApprovedByID] = useState(null);
    const [isEmployeeDataLoaded, setIsEmployeeDataLoaded] = useState(false);

    // Fetch department data
    const fetchEmployee = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadEmployeeList(para);
            if (data && data.length > 0) {
                setApprovedBy(data);

                const initialEmployee = data.find((dept) => dept.id === selectedID);
                setSelectedApprovedBy(initialEmployee);
                setSelectedApprovedByID(initialEmployee.id);
                setIsEmployeeDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isEmployeeDataLoaded && editShiftAssignmentID === 0) {
            fetchEmployee();
        }
    }, [isEmployeeDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadApprovedByID = async (selectedID) => {
        await fetchEmployee(selectedID);
    };

    return {
        approvedBy,
        selectedApprovedBy,
        selectedApprovedByID,
        setSelectedApprovedBy,
        setSelectedApprovedByID,
        loadApprovedByID,
    };
};

export default useApprovedByEmployee;
